import RolesReducer from './RolesReducer';

export default from './RolesContainer';
export const RolesReducers = {
  RolesReducer,
};
